/**
 * DocumentSection Component
 * Section untuk upload dokumen PO (opsional)
 */

import { Box, Flex, Icon } from '@chakra-ui/react';
import { DropzoneMultiple, Text } from '@diamond/shared/ui';
import { UploadFileOutlined } from '@mui/icons-material';
import { useFormContext } from 'react-hook-form';

export interface DocumentSectionProps {
  onRemoveFile: (idx: number) => void;
}

/**
 * DocumentSection Component
 * Upload dokumen PO dengan format PDF, PNG, JPG (max 2MB)
 */
export function DocumentSection({ onRemoveFile }: DocumentSectionProps) {
  const {
    formState: { errors },
  } = useFormContext();

  const maxUploadSize = 2; // MB

  return (
    <Box
      borderWidth="1px"
      borderColor="gray.200"
      borderRadius="lg"
      p={{ base: 4, md: 5 }}
      bg="white"
    >
      <Flex direction="column" gap={4}>
        {/* Title Section */}
        <Flex align="flex-start" gap={3}>
          <Icon
            as={UploadFileOutlined}
            color="#0941A8"
            boxSize={6}
            mt={0.5}
            flexShrink={0}
          />
          <Box flex={1}>
            <Flex align="center" gap={1} mb={1}>
              <Text fontSize="lg" fontWeight="bold" color="gray.900">
                Dokumen PO
              </Text>
              <Text fontSize="sm" color="gray.500">
                *Opsional
              </Text>
            </Flex>
            <Text fontSize="sm" color="gray.600" lineHeight="1.6">
              Hanya menerima format PDF, PNG, JPG dengan ukuran maksimal{' '}
              {maxUploadSize} MB
            </Text>
          </Box>
        </Flex>

        {/* Dropzone - Full Width */}
        <Box w="full">
          <DropzoneMultiple
            name="purchase_order_document"
            accept={{
              'application/pdf': ['.pdf'],
              'image/*': ['.png', '.jpeg', '.jpg'],
            }}
            maxSize={maxUploadSize}
            onRemoveFile={onRemoveFile}
            errors={errors}
            isCentered
          />
        </Box>
      </Flex>
    </Box>
  );
}
